import GlobalLoading from '@kaidam/fc-shared/src/frontend/components/system/GlobalLoading'
export default GlobalLoading